/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";

export const addTestimonial = createAsyncThunk(
  "testimonial/add",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/testimonial", data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllTestimonials = createAsyncThunk(
  "testimonial/all",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/testimonial", { params });
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getTestimonial = createAsyncThunk(
  "testimonial/get",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/testimonial/${id}`);
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateTestimonial = createAsyncThunk(
  "testimonial/update",
  async (
    { id, data }: { id: string | undefined; data: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.patch(`/testimonial/${id}`, data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteTestimonial = createAsyncThunk(
  "testimonial/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/testimonial/${id}`);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

interface TestimonialState {
  isLoading: boolean;
  formLoader: boolean;
  testimonial: any;
  allTestimonials: any;
  error: any;
}

const initialState: TestimonialState = {
  isLoading: false,
  formLoader: false,
  testimonial: null,
  allTestimonials: [],
  error: null,
};

const testimonialSlice: any = createSlice({
  name: "testimonial",
  initialState,
  reducers: { resetState: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(addTestimonial.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(addTestimonial.fulfilled, (state, action) => {
        state.formLoader = false;
        state.testimonial = action.payload?.data?.data;
      })
      .addCase(addTestimonial.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(getAllTestimonials.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllTestimonials.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allTestimonials = action.payload?.data;
      })
      .addCase(getAllTestimonials.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(getTestimonial.pending, (state) => {
        state.isLoading = true;
        state.testimonial = null;
      })
      .addCase(getTestimonial.fulfilled, (state, action) => {
        state.isLoading = false;
        state.testimonial = action.payload?.data;
      })
      .addCase(getTestimonial.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(updateTestimonial.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(updateTestimonial.fulfilled, (state, action) => {
        state.formLoader = false;
        state.testimonial = action.payload?.data?.data;
      })
      .addCase(updateTestimonial.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(deleteTestimonial.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteTestimonial.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteTestimonial.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetState } = testimonialSlice.actions;
export default testimonialSlice.reducer;

